/**
 * Add Discount To Pos Cart Item Dialog
 */

import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Autocomplete,
} from '@mui/material'
/** TYPES */
import type { CartItem } from '@/types/pos'
import type { Discount } from '@/types/discount'
/** SERVICES */
import { fetchDiscounts } from '@/hooks/discount'
/** COMPONENTS */
import { NumericFormat } from 'react-number-format'

interface AddDiscountDialogProps {
    open: boolean;
    cartItem?: CartItem | null;
    onClose: () => void;
    onApplyDiscount: (discount: Discount) => void;
    currentDiscountId?: string | null;
}

const AddDiscountDialog = (props: AddDiscountDialogProps) => {
    const [open, setOpen] = React.useState<boolean>(false)
    const [discounts, setDiscounts] = React.useState<Discount[]>([])
    const [selectedDiscount, setSelectedDiscount] = React.useState<Discount | null>(null)

    React.useEffect(() => {
        if (props.cartItem && props.currentDiscountId && discounts.length > 0) {
            const existingDiscount = discounts.find(d => d.id === props.currentDiscountId) || null;
            setSelectedDiscount(existingDiscount);
        }
    }, [props.cartItem, props.currentDiscountId, discounts]);

    React.useEffect(() => {
        if (props.open) {
            setOpen(true)
            loadDiscounts()
        } else {
            setOpen(false)
            setSelectedDiscount(null)
        }
    }, [props.open])

    const loadDiscounts = React.useCallback(async () => {
        try {
            const fetchedDiscounts = await fetchDiscounts()
            setDiscounts(fetchedDiscounts)
        } catch (error) {
            console.error('Failed to fetch discounts:', error)
        }
    }, [])

    const handleApply = () => {
        if (selectedDiscount) {
            props.onApplyDiscount(selectedDiscount)
            handleClose()
        }
    }

    const handleClose = () => {
        setOpen(false)
        setTimeout(() => {
            props.onClose()
        }, 200)
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle>Хөнгөлөлт нэмэх</DialogTitle>
            <DialogContent>
                <Autocomplete
                    options={discounts}
                    getOptionLabel={(option) => `${option.label}`}
                    renderInput={(params) => <TextField {...params} label="Хөнгөлөлт сонгох" variant="outlined" />}
                    value={selectedDiscount}
                    onChange={(event, newValue) => {
                        setSelectedDiscount(newValue)
                    }}
                    fullWidth
                    sx={{ mt: 2 }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    Болих
                </Button>
                <Button onClick={handleApply} color="primary" variant="contained" disabled={!selectedDiscount}>
                    Хадгалах
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddDiscountDialog